import { UntypedFormControl, FormArray } from '@angular/forms';

export class Fitment {
  mfr_label: UntypedFormControl;
  position_id: UntypedFormControl;
  qty: UntypedFormControl;
}
